import Enums from 'utils/EnumsManager';
import { toUtc, toTimezone } from 'utils/dateTimeUtils';
import { valueToArray } from './criterialUtils';

const { WorkFlow, FieldTypes } = Enums;
const { Distribution } = WorkFlow;
const { DateOnly, DateTime } = FieldTypes;

const updateSessionByObject = (sessions, sessionNum, objectKey) => {
  return sessions.map(session => {
    if (session.sessionNum === sessionNum) {
      return {
        ...session,
        triggerValue: {
          ...session.triggerValue,
          objectKey
        }
      };
    }
    return session;
  });
};

const updateFilterValue = (selectedTriggerActions, displayNum, updateValue, updateKey) => {
  if (!selectedTriggerActions || !_.isArray(selectedTriggerActions) || _.isEmpty(selectedTriggerActions)) return [];
  return selectedTriggerActions.map(action => {
    if (action.displayNum === displayNum) {
      return {
        ...action,
        [updateKey]: updateValue
      };
    }
    return action;
  });
};

const getUpdatedFields = (triggerSession, actionFilters, triggerMeta) => {
  const { objectOptions, fieldsData } = triggerMeta;
  const { sessionNum, triggerValue } = triggerSession;
  const fieldType = objectOptions.find(option => option.object_key === triggerValue.objectKey);
  const actionValue = actionFilters[sessionNum] ? actionFilters[sessionNum] : [];
  const fields = fieldType && fieldType.object_type ? fieldsData[fieldType.object_type] : [];
  const updatedActions = actionValue.map(a => {
    const selectedField = fields.find(field => field.field_name === a.fieldId);
    const updatedValue = {
      field_name: a.fieldId,
      value: {
        type: a.functionType,
        data: a.value,
      },
    };
    if (a.functionType === Distribution) {
      const parseValue = valueToArray(a.value);
      const checkValue = parseValue.some(v => a.distributionValue.some(d => d.value !== v));
      if (_.isEmpty(a.distributionValue) || checkValue) {
        return {
          ...updatedValue,
          value: {
            ...updatedValue.value,
            data: parseValue.map(v => ({ weight: 1, value: v })),
          },
        };
      }
      return {
        ...updatedValue,
        value: {
          ...updatedValue.value,
          data: a.distributionValue,
        },
      };
    }
    if (selectedField.crm_data_type === DateOnly || selectedField.crm_data_type === DateTime) {
      return {
        ...updatedValue,
        value: {
          ...updatedValue.value,
          data: toUtc(a.value, selectedField.crm_data_type === DateTime)
        }
      };
    }
    return updatedValue;
  });
  return updatedActions;
};

const triggerToApi = (triggerSession, actionFilters, triggerMeta) => {
  const { triggerValue } = triggerSession;

  return {
    action_type: triggerValue.triggerType,
    action_detail: {
      object_key: triggerValue.objectKey,
      update_fields: getUpdatedFields(triggerSession, actionFilters, triggerMeta),
    }
  };
};

const parseApiActionValue = (actionValue, selectedField) => {
  const { type, data } = actionValue;
  if (_.isEmpty(actionValue) || (type === Distribution && !_.isArray(data))) return '';
  if (type !== Distribution) {
    if (selectedField && (selectedField.crm_data_type === DateOnly || selectedField.crm_data_type === DateTime)) {
      return toTimezone(data, selectedField.crm_data_type === DateTime);
    }
    return data;
  }
  const parseData = [];
  data.forEach(d => parseData.push(d.value));
  return parseData.join(',').trim();
};

const apiToActionValue = (updatedValue, metaFields) => {
  if (!_.isArray(updatedValue) || _.isEmpty(updatedValue)) return [];
  return updatedValue.map((v, index) => {
    const selectedField = metaFields ? metaFields.find(f => f.field_name === v.field_name) : {};
    return {
      displayNum: index + 1,
      fieldId: v.field_name,
      functionType: v.value.type,
      value: parseApiActionValue(v.value, selectedField),
      distributionValue: v.value.type === Distribution ? v.value.data : [],
    };
  });
};

export {
  updateSessionByObject,
  updateFilterValue,
  triggerToApi,
  apiToActionValue
};



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/utils/triggerUtils.js